<template>
    <div :class="preCls + 'container-padding'">
        <div :class="preCls + 'content-box'">
            <label>开始日期</label>
            <DatePicker
                v-model="startDate"
                transfer
                :class="preCls + 'select-public-style'"
                type="date"
                @on-change="clearFast"
            ></DatePicker>
            <label>结束日期</label>
            <DatePicker
                v-model="endDate"
                transfer
                :class="preCls + 'select-public-style'"
                type="date"
                @on-change="clearFast"
            ></DatePicker>
            <check-tag-group
                style="display: inline-block"
                v-model="fastDate"
                color="primary"
                @on-change="getEndStart"
            >
                <check-tag v-for="item in fastDateList" :name="item.id" :key="item.id">{{item.text}}</check-tag>
            </check-tag-group>
            <Tabs class="router-view" :animated="false" v-model="active" @on-click="tabsChange">
                <TabPane label="任务列表" :index="1" name="taskList">
                    <Access name="taskList">
                        <router-view
                            :date="filter"
                            v-if="active == 'taskList'"
                            :name="$access.aliasToUri('taskList')"
                        ></router-view>
                    </Access>
                </TabPane>
                <TabPane label="任务分析" :index="2" name="taskAnalysis">
                    <Access name="taskAnalysis">
                        <router-view
                            :date="filter"
                            v-if="active == 'taskAnalysis'"
                            :name="$access.aliasToUri('taskAnalysis')"
                        ></router-view>
                    </Access>
                </TabPane>
                <TabPane label="任务监控" :index="3" name="taskMonitor">
                    <Access name="taskMonitor">
                        <router-view
                            :date="filter"
                            v-if="active == 'taskMonitor'"
                            :name="$access.aliasToUri('taskMonitor')"
                        ></router-view>
                    </Access>
                </TabPane>
                <TabPane label="任务咨询" :index="4" name="taskConsult">
                    <Access name="taskConsult">
                        <router-view
                            :date="filter"
                            v-if="active == 'taskConsult'"
                            :name="$access.aliasToUri('taskConsult')"
                        ></router-view>
                    </Access>
                </TabPane>
            </Tabs>
        </div>
    </div>
</template>
<script>
import { Tabs, TabPane } from 'ivux'
import dayjs from 'dayjs'
export default {
    components: {
        Tabs,
        TabPane
    },
    data() {
        return {
            active: 'taskList',
            fastDateList: [
                { id: 7, text: '近7天' },
                { id: 30, text: '近30天' },
                { id: 90, text: '近90天' }
            ],
            filter: {
                startDate: this.$cache.startDate,
                endDate: this.$cache.endDate
            },
            fastDate: []
        }
    },
    computed: {
        startDate: {
            get() {
                return this.filter.startDate
                    ? new Date(this.filter.startDate)
                    : ''
            },
            set(el) {
                this.filter.startDate = el ? dayjs(el).format('YYYY-MM-DD') : ''
                this.$cache.startDate = this.filter.startDate
            }
        },
        endDate: {
            get() {
                return this.filter.endDate ? new Date(this.filter.endDate) : ''
            },
            set(el) {
                this.filter.endDate = el ? dayjs(el).format('YYYY-MM-DD') : ''
                this.$cache.endDate = this.filter.endDate
            }
        }
    },
    methods: {
        tabsChange(el) {},
        getEndStart(el) {
            if (el && el.length) {
                let body = {
                    startDate: dayjs()
                        .subtract(el[0], 'day')
                        .format('YYYY-MM-DD'),
                    endDate: dayjs().format('YYYY-MM-DD')
                }
                this.filter = body
            }
        },
        clearFast() {
            this.fastDate = []
        }
    }
}
</script>